import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: wishlist-button;

  background-color: transparent;
  border-radius: ${theme.borderRadius.mega};
  border: 1px solid ${theme.colors.p500};
  color: ${theme.colors.p500};
  cursor: pointer;
  display: inline-block;
  outline: none;
  padding: ${theme.spacings.bit} ${theme.spacings.byte};
  transition: background-color 0.3s ease-in-out;
`

export const Button = styled('button')(baseStyles)
